(function () {
    function initAvatarDropdown() {
        const li = document.getElementById("website-post-login");
        if (!li || li.dataset.ddInit) return;
        const toggle = li.querySelector(".nav-avatar");
        const menu = li.querySelector(".dropdown-menu");
        if (!toggle || !menu) return;

        li.dataset.ddInit = "1";
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const open = li.classList.contains("show");
            li.classList.toggle("show", !open);
            menu.classList.toggle("show", !open);
            toggle.setAttribute("aria-expanded", String(!open));
        });
        document.addEventListener("click", function (e) {
            if (!li.contains(e.target)) {
                li.classList.remove("show");
                menu.classList.remove("show");
                toggle.setAttribute("aria-expanded", "false");
            }
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAvatarDropdown);
    } else {
        initAvatarDropdown();
    }
})();

frappe.ready(() => {
    const path = window.location.pathname || "";
    if (!path.startsWith("/address")) return;

    const applyAddressButtonClasses = () => {
        const primarySelectors = [
            ".web-list-actions .button-new",
            ".web-form-actions .submit-btn",
        ];
        const secondarySelectors = [
            ".web-form-actions .discard-btn",
            ".web-form-actions .delete-btn",
            ".web-form-actions .edit-button",
            ".web-form-actions .print-btn",
            ".web-form-actions .btn-next",
            ".web-form-actions .btn-previous",
            ".web-list-footer .more",
        ];

        const mapButtons = (selectors, cls) => {
            selectors.forEach((selector) => {
                document.querySelectorAll(selector).forEach((button) => {
                    button.classList.remove(
                        "btn-primary",
                        "btn-default",
                        "btn-secondary",
                        "btn-danger",
                        "button-delete"
                    );
                    button.classList.add(cls);
                });
            });
        };

        mapButtons(primarySelectors, "primary-btn");
        mapButtons(secondarySelectors, "secondary-btn");
    };

    const applyAddressTableDataLabels = () => {
        const table = document.querySelector('[data-path="/address/list"] .web-list-table');
        if (!table) return;

        const headers = Array.from(table.querySelectorAll("thead th")).map((th) =>
            (th.textContent || "").trim()
        );

        table.querySelectorAll("tbody tr").forEach((row) => {
            row.querySelectorAll("td").forEach((cell, index) => {
                const label = headers[index] || "";
                if (label) {
                    cell.setAttribute("data-label", label);
                }
            });
        });
    };

    let isFrameQueued = false;
    const syncAddressPortalUI = () => {
        if (isFrameQueued) return;
        isFrameQueued = true;

        window.requestAnimationFrame(() => {
            applyAddressButtonClasses();
            applyAddressTableDataLabels();
            isFrameQueued = false;
        });
    };

    syncAddressPortalUI();

    const observerTarget = document.querySelector(".page_content") || document.body;
    new MutationObserver(syncAddressPortalUI).observe(observerTarget, {
        childList: true,
        subtree: true,
    });
});